<template>
	<div class="tpl my-certification-wrap">
		<mt-header title="信用认证" fixed>
			<router-link :to="{name:'mine'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
			<mt-button  slot="right" @click.native="showAlert=1">认证作用？</mt-button>
		</mt-header>
		<div class="certification-list">
			<p class="title">基本认证</p>
			<ul>
				<router-link tag="li" to="" @click.native="listInfo.is_phone==0&&showCertiP(listInfo.is_phone)">
					<span class="name">手机号认证</span>
					<span class="value">
						<span v-if="listInfo.is_phone==1" class="yes">已认证</span>
						<span v-else class="no">去认证<img src="../../assets/img/mine/center_ic_list_enter.png" alt="" /></span>
					</span>
				</router-link>
				<router-link tag="li" :to="{name:'certi-name'}">
					<span class="name">实名认证</span>
					<span class="value">
						<span v-if="listInfo.is_real==1" class="yes">已认证</span>
						<span v-else class="no">去认证<img src="../../assets/img/mine/center_ic_list_enter.png" alt="" /></span>
					</span>
				</router-link>
				<router-link tag="li" :to="{name:'certi-edu'}">
					<span class="name">学历认证</span>
					<span class="value">
						<span v-if="listInfo.is_education==1" class="yes">已认证</span>
						<span v-else class="no">去认证<img src="../../assets/img/mine/center_ic_list_enter.png" alt="" /></span>
					</span>
				</router-link>
			</ul>
			
			<p class="title">资产认证</p>
			<ul>
				<router-link tag="li" :to="{name:'certi-house'}">
					<span class="name">房产认证</span>
					<span class="value">
						<span v-if="listInfo.is_house==1" class="yes">已认证</span>
						<span v-else class="no">去认证<img src="../../assets/img/mine/center_ic_list_enter.png" alt="" /></span>
					</span>
				</router-link>
				<router-link tag="li" :to="{name:'certi-car'}">
					<span class="name">车辆认证</span>
					<span class="value">
						<span v-if="listInfo.is_vehicle==1" class="yes">已认证</span>
						<span v-else class="no">去认证<img src="../../assets/img/mine/center_ic_list_enter.png" alt="" /></span>
					</span>
				</router-link>
			</ul>
		</div>
		<common-alert v-if="showAlert" @hideAlert="hideAlert">
			<p slot="title" class="title">{{alertInfo.title}}</p>
			<div class="content" slot="content" v-html="alertInfo.text"></div>
		</common-alert>
		<certi-phone @hide="hideCertiPhone" v-if="showCertiPhone"></certi-phone>
	</div>
</template>

<script>
	
	import CommonAlert from "../Common/CommonAlert"
	import CertiPhone from "./CertiPhone"
	
	
	export default{
		name:"my-certification",
		components:{
			CommonAlert,
			CertiPhone
		},
		data(){
			return{
				uid:"",
				listInfo:"",
				showAlert:0,
				alertInfo:{
					title:"认证作用？",
					text:"<p>1：认证可以获得积分。</p><p>2：认证可以提高魅力等级，让大家更容易记住你。</p>"
				},
				showCertiPhone:0,
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
			
			this.getInfo();
		},
		methods:{
			getInfo(){
				this.$axios({
					url:"My/MyAuthenticationList",
					method:"post",
					data:{
						uid:this.uid
					}
				}).then(res=>{
					console.log(res.data.data[0]);
					if(res.data.code==200){
						this.listInfo=res.data.data[0];
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			hideAlert(){
				this.showAlert = 0
			},
			showCertiP(isOk){
				console.log(isOk);
//				if(isOk==1){
//					this.$toast({message:"您已经认证了手机号哦~",position:"bottom",duration:3000})
//				}else{
					this.showCertiPhone = 1;
//				}
			},
			hideCertiPhone(){
				this.showCertiPhone = 0;
			}
		}
	}
</script>

<style scoped>
	>>>.mint-button-text{
		color: #5415F9;
	}
	.my-certification-wrap{
		padding-top: 2.5rem;
	}
	.certification-list .title{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		line-height: 1.5rem;
		padding: 0.8rem 1rem;
		background: #fff;
		border-bottom: 1px solid #eee;
	}
	.certification-list ul{
		margin-bottom: 1rem;
	}
	.certification-list li{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.6rem 1rem;
		font-size: 0.8rem;
		color: #282828;
		background: #fff;
		border-bottom: 1px solid #eee;
		line-height: 1.2rem;
	}
	.certification-list li:active{
		background: #fafafa;
	}
	.certification-list li .value{
		
	}
	.certification-list li .yes{
		color: #7b7b7b;
		margin-right: 1.5rem;
	}
	.certification-list li .no{
		color: #FF6161;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	} 
	.certification-list li .no:active{
		opacity: 0.7;
	}
	.certification-list li .no img{
		width: 1.5rem;
	}
	
	
</style>


// WEBPACK FOOTER //
// src/components/Mine/MyCertification.vue